<script>
import { Head } from '@inertiajs/inertia-vue3';
import { BookOpen, LayoutDashboard, LogOut, Store, ChevronRight, MapPin } from 'lucide-vue-next';
import { Button } from '@/Components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/Components/ui/card';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/Components/ui/select';

export default {
    components: {
        Head,
        BookOpen, LayoutDashboard, LogOut, Store, ChevronRight, MapPin,
        Button,
        Card, CardContent, CardHeader, CardTitle, CardDescription,
        Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
    },

    data() {
        return {
            shops: this.$page.props.shops,
            shop: this.$page.props.shop,
        };
    },

    methods: {
        logout() {
            this.$inertia.post(route('logout'));
        },

        loginShop() {
            this.$inertia.post(route('shop_module.login'), {
                shop_id: this.shop.id,
            });
        },
    },
};
</script>

<template>
    <Head title="Chọn cửa hàng" />

    <div class="min-h-screen bg-muted">
        <!-- Header -->
        <header class="border-b bg-background">
            <div class="mx-auto flex h-16 max-w-5xl items-center justify-between px-4">
                <div class="flex items-center gap-2 font-semibold text-primary">
                    <BookOpen class="h-6 w-6" />
                    <span>Đông Tây ERP</span>
                </div>
                <div class="flex items-center gap-2">
                    <Button as-child variant="default" size="sm">
                        <a :href="route('admin.dashboard.index')">
                            <LayoutDashboard class="mr-2 h-4 w-4" />
                            Truy cập admin
                        </a>
                    </Button>
                    <Button variant="outline" size="sm" @click="logout">
                        <LogOut class="mr-2 h-4 w-4" />
                        Đăng xuất
                    </Button>
                </div>
            </div>
        </header>

        <!-- Nội dung -->
        <main class="mx-auto max-w-5xl px-4 py-10">
            <p class="mb-6 text-muted-foreground">
                Xin chào, <span class="font-semibold text-foreground">{{ $page.props.user.name }}</span>
            </p>

            <div class="mx-auto max-w-md space-y-6">
                <Card>
                    <CardHeader>
                        <CardTitle class="text-lg">Chọn cửa hàng</CardTitle>
                        <CardDescription>Chọn cửa hàng bạn muốn truy cập</CardDescription>
                    </CardHeader>
                    <CardContent>
                        <Select v-model="shop" by="id">
                            <SelectTrigger>
                                <SelectValue placeholder="Tìm kiếm cửa hàng...">
                                    <span v-if="shop" class="flex items-center gap-2">
                                        <Store class="h-4 w-4 text-primary" />
                                        {{ shop.name }}
                                    </span>
                                </SelectValue>
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem v-for="s in shops" :key="s.id" :value="s">
                                    <span class="flex items-center gap-2">
                                        <Store class="h-4 w-4 text-primary" />
                                        {{ s.name }}
                                    </span>
                                </SelectItem>
                            </SelectContent>
                        </Select>
                    </CardContent>
                </Card>

                <Card v-if="shop">
                    <CardContent class="pt-6">
                        <h5 class="text-lg font-semibold">{{ shop.name }}</h5>
                        <p class="mt-1 flex items-center gap-1 text-sm text-muted-foreground">
                            <MapPin class="h-4 w-4" />
                            Số 1 Hoàng Văn Thụ, Quận 1
                        </p>
                        <Button class="mt-4" @click="loginShop">
                            <ChevronRight class="mr-1 h-4 w-4" />
                            Truy cập cửa hàng
                        </Button>
                    </CardContent>
                </Card>
            </div>
        </main>
    </div>
</template>
